export default __webpack_public_path__ + "static/media/agencyhabitat.png";